import { useContext, useEffect, useState } from "react";
import { EnrollerType } from "../@types/user.types";
import { AuthContext } from "../contexts";

const useEnroller = (): {
	isEnroller: boolean;
	enrollerRole: EnrollerType | null;
} => {
	const { user } = useContext(AuthContext);
	const [enrollerRole, setEnrollerRole] = useState<EnrollerType | null>(null);
	const [isEnroller, setIsEnroller] = useState<boolean>(false);

	useEffect(() => {
		if (user?.role === "EMPLOYER" && user?.type) {
			setIsEnroller(true);
			setEnrollerRole(user.type);
		}
	}, [user?.role, user?.type]);

	return { isEnroller, enrollerRole };
};

export default useEnroller;
